import type { Pruefstatus } from '@hofsync/design-system';

/**
 * The demo's areas carry the ids of `config/rules/pruefstatus.yaml` (FR-017 #7b,
 * review r1 P2-5): the drill-down selects events by the area's event types, as
 * the live backend does, via {@link MOCK_AREA_EVENT_TYPES}.
 */
export const MOCK_PRUEFSTATUS: Pruefstatus = {
  overall_status: 'has_issues',
  overall_label: 'Handlungsbedarf',
  last_updated: '2024-12-01T10:00:00Z',
  areas: [
    {
      area_id: 'fertilization',
      area_name: 'Düngung',
      status: 'has_issues',
      open_action_required: 2,
      open_warnings: 0,
      total_contracts: 3,
      fulfilled_contracts: 1,
      summary_text: '2 fehlende Sicherheitsdatenblätter (DüMV §7). 1 Preisabweichung bei BayWa-Kontrakt.',
    },
    {
      area_id: 'seeds',
      area_name: 'Saatgut',
      status: 'has_warnings',
      open_action_required: 0,
      open_warnings: 1,
      total_contracts: 1,
      fulfilled_contracts: 0,
      summary_text: 'Saatgut-Kontrakt K-2024-015 läuft in 28 Tagen ab. Lieferung noch ausstehend.',
    },
    {
      area_id: 'harvest',
      area_name: 'Ernte',
      status: 'has_issues',
      open_action_required: 1,
      open_warnings: 1,
      total_contracts: 2,
      fulfilled_contracts: 0,
      summary_text: 'Kommissionsabweichung bei FRUTANiA-Gutschrift. Überlieferung bei Winterweizen.',
    },
  ],
};

/** Mirror of `config/rules/pruefstatus.yaml` `areas[].event_types`, for the demo drill-down. */
export const MOCK_AREA_EVENT_TYPES: Record<string, readonly string[]> = {
  fertilization: ['missing_datasheet', 'price_discrepancy', 'contract_expiring'],
  seeds: ['contract_expiring', 'price_discrepancy'],
  harvest: ['commission_mismatch', 'price_discrepancy'],
  links: ['link_expected_missing', 'link_ownership_conflict', 'link_price_conflict', 'validity_expiring'],
};
